/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-27 09:46:28
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-06 10:05:19
 * @FilePath: /goldenSalesMobile/src/api/goods.js
 * @Description: 商品列表相关api
 */
import { $http, requestOfPost } from '@/utils/http'
import { requestOfGet } from '../utils/http'
const baseUrl = 'wechath5/zh-cn/v1/'

// 分类列表
export function getProductTypeList(param) {
  return requestOfGet(`${baseUrl}producttype`, param)
}

// 产品列表
export function getProductList(param) {
  return requestOfGet(`${baseUrl}product`, param)
}

// 产品详情
export function getProductDetail(param) {
  return requestOfGet(`${baseUrl}product`, param)
}

// 获取产品海报
export function getProductPoster(param) {
  return requestOfGet(`${baseUrl}product/${param}/poster`)
}

// 测试
export function tt(param){
  return $http(`${baseUrl}producttype`, param);
}


export function queryConsumeitems(data) { //评价项目
  return requestOfGet(`${baseUrl}comment/projects/`+data)
}

export function applyAddEvaluate(data) { //新增评价
  return requestOfPost(`${baseUrl}/comment/add`, data)
}

export function queryEvaluate(data) { //查询评价
  return requestOfGet(`${baseUrl}comment`,data)
}